/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrderInfoForClientSkuVo } from './OrderInfoForClientSkuVo';
import {
    OrderInfoForClientSkuVoFromJSON,
    OrderInfoForClientSkuVoFromJSONTyped,
    OrderInfoForClientSkuVoToJSON,
    OrderInfoForClientSkuVoToJSONTyped,
} from './OrderInfoForClientSkuVo';

/**
 * 
 * @export
 * @interface PageDataOrderInfoForClientSkuVo
 */
export interface PageDataOrderInfoForClientSkuVo {
    /**
     * 当前页
     * @type {number}
     * @memberof PageDataOrderInfoForClientSkuVo
     */
    currentPage?: number;
    /**
     * 总页数
     * @type {number}
     * @memberof PageDataOrderInfoForClientSkuVo
     */
    totalPage?: number;
    /**
     * 总记录数
     * @type {number}
     * @memberof PageDataOrderInfoForClientSkuVo
     */
    totalRecord?: number;
    /**
     * 列表内容
     * @type {Array<OrderInfoForClientSkuVo>}
     * @memberof PageDataOrderInfoForClientSkuVo
     */
    records?: Array<OrderInfoForClientSkuVo>;
}

/**
 * Check if a given object implements the PageDataOrderInfoForClientSkuVo interface.
 */
export function instanceOfPageDataOrderInfoForClientSkuVo(value: object): value is PageDataOrderInfoForClientSkuVo {
    return true;
}

export function PageDataOrderInfoForClientSkuVoFromJSON(json: any): PageDataOrderInfoForClientSkuVo {
    return PageDataOrderInfoForClientSkuVoFromJSONTyped(json, false);
}

export function PageDataOrderInfoForClientSkuVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageDataOrderInfoForClientSkuVo {
    if (json == null) {
        return json;
    }
    return {
        
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'totalPage': json['totalPage'] == null ? undefined : json['totalPage'],
        'totalRecord': json['totalRecord'] == null ? undefined : json['totalRecord'],
        'records': json['records'] == null ? undefined : ((json['records'] as Array<any>).map(OrderInfoForClientSkuVoFromJSON)),
    };
}

export function PageDataOrderInfoForClientSkuVoToJSON(json: any): PageDataOrderInfoForClientSkuVo {
    return PageDataOrderInfoForClientSkuVoToJSONTyped(json, false);
}

export function PageDataOrderInfoForClientSkuVoToJSONTyped(value?: PageDataOrderInfoForClientSkuVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentPage': value['currentPage'],
        'totalPage': value['totalPage'],
        'totalRecord': value['totalRecord'],
        'records': value['records'] == null ? undefined : ((value['records'] as Array<any>).map(OrderInfoForClientSkuVoToJSON)),
    };
}

